module.exports = __webpack_public_path__ + "img/cross.329dac81.svg";